<template>
  <UiDialog
    class="SourceButton"
    :open.sync="isOpen"
    :close-scrim="false"
  >
    <template #trigger>
      <UiIcon
        :title="$t('SourceButton.title')"
        value="mdi:code-tags"
        class="ToolbarButton"
      ></UiIcon>
    </template>

    <template #contents>
      <textarea
        v-model="stringValue"
        class="SourceButton__textarea"
      ></textarea>
    </template>

    <template #footer>
      <button
        type="button"
        class="ui-native --main"
        @click="onAccept"
      >{{ $t('SourceButton.Accept') }}</button>
      <button
        type="button"
        class="ui-native --cancel"
        @click="onCancel"
      >{{ $t('SourceButton.Cancel') }}</button>
    </template>
  </UiDialog>
</template>

<script>
import useI18n from '@/modules/i18n/mixins/useI18n.js';
import { UiIcon, UiDialog, UiInput } from '@/modules/ui/components';

export default {
  components: {
    UiIcon,
    UiDialog,
    UiInput,
  },

  mixins: [useI18n],

  props: {
    editor: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
      stringValue: '',
    };
  },

  methods: {
    onAccept() {
      this.editor.commands.setContent(this.stringValue, true);
      this.isOpen = false;
    },

    onCancel() {
      this.stringValue = this.editor.getHTML();
      this.isOpen = false;
    },
  },

  computed: {
    currentText() {
      return this.editor.getHTML();
    },
  },

  watch: {
    currentText: {
      immediate: true,
      handler() {
        this.stringValue = this.editor.getHTML();
      },
    },
  },

  i18n: {
    en: {
      'SourceButton.title': 'HTML source',
      'SourceButton.Accept': 'Accept',
      'SourceButton.Cancel': 'Cancel',
    },
    es: {
      'SourceButton.title': 'Fuente HTML',
      'SourceButton.Accept': 'Aceptar',
      'SourceButton.Cancel': 'Cancelar',
    },
    de: {
      'SourceButton.title': 'HTML-Quelle',
      'SourceButton.Accept': 'Akzeptieren',
      'SourceButton.Cancel': 'Abbrechen',
    },
    fr: {
      'SourceButton.title': 'Source HTML',
      'SourceButton.Accept': 'Accepter',
      'SourceButton.Cancel': 'Annuler',
    },
    it: {
      'SourceButton.title': 'Fonte HTML',
      'SourceButton.Accept': 'Accettare',
      'SourceButton.Cancel': 'Annullamento',
    },
    pt: {
      'SourceButton.title': 'Fonte HTML',
      'SourceButton.Accept': 'Aceitar',
      'SourceButton.Cancel': 'Cancelar',
    },
  },
};
</script>

<style lang="scss">
.SourceButton {
  &__textarea {
    display: block;
    resize: vertical;
    width: 100%;
    height: 420px;
  }
}
</style>